import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutingPathsEnum } from 'src/app/core/services/routing/routing.service';
import { CoAppInviteComponent } from './co-app-invite/co-app-invite.component';
import { AuthenticationGuard } from 'src/app/core/guards/authentication.guard';
import { LoanApplicationResolver } from 'src/app/core/guards/loan-application.resolver';
import { CoAppInviteSentComponent } from './co-app-invite-sent/co-app-invite-sent.component';
import { CoAppLandingComponent } from './co-app-landing/co-app-landing.component';
import { CoAppApplyResolver } from './co-app.resolver';

const routes: Routes = [
	{
		path: RoutingPathsEnum.coAppApply,
		component: CoAppLandingComponent,
		resolve: { coAppDetails: CoAppApplyResolver }
	},
	{
		path: RoutingPathsEnum.coApp,
		canActivate: [AuthenticationGuard],
		resolve: { loanApp: LoanApplicationResolver },
		children: [
			{
				path: RoutingPathsEnum.invite,
				component: CoAppInviteComponent
			},
			{
				path: RoutingPathsEnum.inviteSent,
				component: CoAppInviteSentComponent
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class CoAppRoutingModule {}
